export class GeoCircleModel {
    latitude: number;
    longitude: number;
    radius: number;
    radiusUnit: GeoRadiusUnit;
    constructor() {
        this.latitude = null;
        this.longitude = null;
        this.radius = 10;
        this.radiusUnit = GeoRadiusUnit.mile;
    }
}

export enum GeoRadiusUnit {
    km = 'KM',
    mile = 'MI'
}
